import styled, { keyframes } from "styled-components";
import { PageContainerStyled } from "styles/common.styles";

// Shared motion primitives for Talent Mobility — a subtle per-screen "enter"
// transition (since react-router remounts the page component on navigation,
// a mount animation on the outer container reads as a screen transition),
// plus a reveal animation for the module's manually-toggled expand panels
// (RoleBoxNode's successor list, SkillGapAccordion) that don't get antd
// Collapse's built-in motion for free.

const fadeSlideIn = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
`;

const expandIn = keyframes`
  from { opacity: 0; transform: translateY(-6px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const PageTransitionStyled = styled(PageContainerStyled)`
  animation: ${fadeSlideIn} 0.22s ease-out;
`;

export const ExpandPanelAnimationStyled = styled.div`
  animation: ${expandIn} 0.18s ease-out;
`;
